import { MAGNETIC_TOKENS } from '@appd/uik';

interface EmptyBoxProps {
  message?: string;
}

const { TYPOGRAPHY } = MAGNETIC_TOKENS;

export const EmptyBox = ({ message = 'No data' }: EmptyBoxProps): JSX.Element => {
  return (
    <div className="flex justify-center items-center h-full rounded-lg py-4 bg-default-bg-medium">
      <p style={{ font: TYPOGRAPHY.P3_DEFAULT }} className="text-center text-default-text-medium">
        {message}
      </p>
    </div>
  );
};
